// SSORoute.js
import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from './AuthContext';

const SSORoute = ({ element: Element }) => {
  const { isSSO, checkSSOLogin } = useAuth();
  const [isChecking, setIsChecking] = useState(true);

  useEffect(() => {
    const checkAuth = () => {
      const isLoggedIn = checkSSOLogin();
      setIsChecking(false);
    };
    checkAuth();
  }, [checkSSOLogin]);

  if (isChecking) {
    return <div>Loading...</div>;
  }

  if (!isSSO) {
    return <Navigate to="/sso-login" replace />;
  }

  return <Element />;
};

export default SSORoute;
